import React, { useState } from 'react'
import { createTip } from "../redux/features/tipSlice";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
    MDBBtn,
} from "mdb-react-ui-kit";

import { Typography, Button, Form } from 'antd';
import QuillEditor from '../components/QuillEditor';

const { Title } = Typography;


function AddTips() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { id } = useParams(); 
    const [content, setContent] = useState("")
    const [files, setFiles] = useState([])

    const onEditorChange = (value) => {
        setContent(value)
    }

    const onFilesChange = (value) => {
        setFiles(files)
    }

    const onSubmit = (e) => { 
        e.preventDefault();
        dispatch(createTip({
            navigate, 
            toast,
            contentData: content,
            contentID: id
        }));
    }

    return (
        <div style={{   margin: "auto",
                        padding: "15px",
                        maxWidth: "1000px",
                        alignContent: "center",
                        marginTop: "100px", 
                    }}>
            <div style={{ textAlign: 'center' }}>
                <Title level={2} > Insira uma dica</Title>
            </div>
            <QuillEditor
                placeholder={"Start Posting Something"}
                onEditorChange={onEditorChange}
                onFilesChange={onFilesChange}
            />
            <MDBBtn style={{ width: "100%" }} onClick={onSubmit}>Salvar</MDBBtn>
        </div>
    )
}

export default AddTips
